import type { InjectionKey } from "vue";

export const isChooseNewDeviceStepAvailableKey = Symbol(
    "isChooseNewDeviceStepAvailableKey",
) as InjectionKey<boolean>;
